import { gql } from 'graphql-request'

export const M_SET_DEFAULT_PAYMENT_METHOD = gql`
  mutation SetDefaultPaymentMethod($paymentMethodId: String!) {
    setDefaultPaymentMethod(paymentMethodId: $paymentMethodId) {
      ... on PaymentMethodMutationResult {
        success
      }
      ... on MutationFailure {
        errors {
          message
        }
      }
    }
  }
`

export const M_DELETE_PAYMENT_METHOD = gql`
  mutation DeletePaymentMethod($paymentMethodId: String!) {
    deletePaymentMethod(paymentMethodId: $paymentMethodId) {
      ... on PaymentMethodMutationResult {
        success
      }
      ... on MutationFailure {
        errors {
          message
        }
      }
    }
  }
`
